module.exports = __webpack_public_path__ + "static/media/image4.4f022ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/carAuthorization/img/image4.png
// module id = 328
// module chunks = 0